import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const calculateWrapperStyles = props => {
  let style;
  switch (props.type) {
    case 'monitoring':
      style = css`
        width: ${pxToRem('72px')};
        height: ${pxToRem('32px')};
        position: relative;
        margin: 0 ${pxToRem('24px')};
        box-shadow: 0 ${pxToRem('13px')} ${pxToRem('15px')} -${pxToRem('10px')} ${props.theme.colors.blueShadow};

        label {
          margin: ${props.margin};
        }

        .ios-toggle,
        .ios-toggle:active {
          position: absolute;
          height: 100%;
          width: 100%;
          opacity: 0;
          border: none;
          z-index: 100;
          outline: none;
          cursor: pointer;
        }

        .ios-toggle:checked + .checkbox-label {
          background: ${props.theme.colors.blue.one};
        }

        .ios-toggle:checked + .checkbox-label:before {
          left: calc(100% - ${pxToRem('30px')});
          top: ${pxToRem('5px')};
        }

        ${props.disabled &&
          css`
            > input {
              cursor: not-allowed !important;
            }
          `};

        ${props.customMargin &&
          css`
            margin: ${props.customMargin};
          `}
      `;
      break;
    case 'login':
    default:
      style = css`
        width: ${pxToRem('42px')};
        position: relative;
        margin-right: ${pxToRem('16px')};
        max-height: 100%;

        label {
          margin: ${props.margin};
        }

        .ios-toggle,
        .ios-toggle:active {
          position: absolute;
          height: 100%;
          width: 100%;
          opacity: 0;
          border: none;
          z-index: 100;
          outline: none;
          cursor: pointer;
        }

        .ios-toggle:checked + .checkbox-label {
          background: #00d7a3;
        }

        .ios-toggle:checked + .checkbox-label:before {
          left: calc(100% - ${pxToRem('22px')});
          top: ${pxToRem('3px')};
        }

        ${props.disabled &&
          css`
            > input {
              cursor: not-allowed !important;
            }
          `};

        ${props.customMargin &&
          css`
            margin: ${props.customMargin};
          `}
      `;
      break;
  }

  return style;
};

const calculateCheckboxLabelStyles = props => {
  let style;
  switch (props.type) {
    case 'monitoring':
      style = css`
        display: block;
        position: relative;
        width: 100%;
        height: ${pxToRem('34px')};
        -webkit-border-radius: ${pxToRem('11px')};
        -moz-border-radius: ${pxToRem('11px')};
        border-radius: ${pxToRem('11px')};
        background-color: ${props.theme.colors.blue.one};
        cursor: pointer;
        transition: background-color 0.25s ease-in-out;
        &:before {
          content: '';
          display: block;
          position: absolute;
          z-index: 1;
          line-height: ${pxToRem('20px')};
          height: ${pxToRem('24px')};
          width: ${pxToRem('24px')};
          border: ${pxToRem('1px')} solid white;
          top: ${pxToRem('5px')};
          left: ${pxToRem('6px')};
          right: auto;
          background: white;
          -webkit-border-radius: 100%;
          -moz-border-radius: 100%;
          border-radius: 100%;
          -webkit-transition: 0.25s ease-in-out;
          -moz-transition: 0.25s ease-in-out;
          -o-transition: 0.25s ease-in-out;
          transition: 0.25s ease-in-out;
          border-radius: ${pxToRem('6px')};
          box-shadow: 0 ${pxToRem('1px')} ${pxToRem('3px')} 0
            rgba(0, 0, 0, 0.26);
        }

        ${props.disabled &&
          css`
            opacity: 0.6;
            cursor: not-allowed;
          `};
      `;
      break;
    case 'login':
    default:
      style = css`
        display: block;
        position: relative;
        width: 100%;
        height: ${pxToRem('24px')};
        -webkit-border-radius: ${pxToRem('12px')};
        -moz-border-radius: ${pxToRem('12px')};
        border-radius: ${pxToRem('12px')};
        background-color: ${props.checked
          ? 'rgba(255, 255, 255, 0.5)'
          : props.theme.colors.black.five};
        cursor: pointer;
        transition: background-color 0.25s ease-in-out;
        &:before {
          content: '';
          display: block;
          position: absolute;
          z-index: 1;
          line-height: ${pxToRem('20px')};
          height: ${pxToRem('18px')};
          width: ${pxToRem('18px')};
          border: ${pxToRem('1px')} solid white;
          top: ${pxToRem('3px')};
          left: ${pxToRem('4px')};
          right: auto;
          background: white;
          -webkit-border-radius: 100%;
          -moz-border-radius: 100%;
          border-radius: 100%;
          -webkit-transition: 0.25s ease-in-out;
          -moz-transition: 0.25s ease-in-out;
          -o-transition: 0.25s ease-in-out;
          transition: 0.25s ease-in-out;
        }

        ${props.disabled &&
          css`
            opacity: 0.6;
            cursor: not-allowed;
          `};
      `;
      break;
  }

  return style;
};

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.white};

  > div:first-child {
    margin-right: ${pxToRem('16px')};
  }
`;

const CheckboxLabel = styled.label`
  ${props => calculateCheckboxLabelStyles(props)};
`;

const ToggleSwitchWrapper = styled.div`
  ${props => calculateWrapperStyles(props)};
`;
const OptionOne = styled.div`
  text-transform: capitalize;
  color: ${props =>
    (!props.checked
      ? props.theme.colors.blue.one
      : props.theme.colors.black.one)};
`;

const OptionTwo = styled.div`
  text-transform: capitalize;
  color: ${props =>
    (props.checked ? props.theme.colors.blue.one : props.theme.colors.black.one)};
`;

export {
  ToggleSwitchWrapper,
  CheckboxLabel,
  ToggleWrapper,
  OptionOne,
  OptionTwo
};
